import type { Action, ThunkAction } from "@reduxjs/toolkit"
import { combineSlices, configureStore } from "@reduxjs/toolkit"
import { setupListeners } from "@reduxjs/toolkit/query"
import { authSlice } from "./auth/createAuthSlice.ts"
import { alumniPortalApi, publicApi } from "./appApiSlice.ts"

const rootReducer = combineSlices(authSlice, alumniPortalApi, publicApi)

export type RootState = ReturnType<typeof rootReducer>

export const makeStore = (preloadedState?: Partial<RootState>) => {
    const store = configureStore({
        reducer: rootReducer,
        middleware: getDefaultMiddleware => {
            return getDefaultMiddleware()
                .concat(alumniPortalApi.middleware)
                .concat(publicApi.middleware)
        },
        preloadedState,
    })
    setupListeners(store.dispatch)
    return store
}

export const store = makeStore()

export type AppStore = typeof store

export type AppDispatch = AppStore["dispatch"]

export type AppThunk<ThunkReturnType = void> = ThunkAction<
    ThunkReturnType,
    RootState,
    unknown,
    Action
>